module.exports = __webpack_public_path__ + "img/8.90bc90f1.jpg";